export default __webpack_public_path__ + "static/media/icon-claim-management.18cff3b3.svg";